import { render, staticRenderFns } from "./news_course_detail.vue?vue&type=template&id=274eac14&"
import script from "./news_course_detail.vue?vue&type=script&lang=js&"
export * from "./news_course_detail.vue?vue&type=script&lang=js&"
import style0 from "./news_course_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports